// extracted by mini-css-extract-plugin
module.exports = {"description":"src-reactapp-Settings-ProofreaderSettings---description"};